const COMPLIANCE_WARNING_MESSAGE_CONVERTIBLE_WITH_144A =
  'You do not have the ability to view Offering Details because we are unable to verify that you have a relationship with one or more managers on this offering or you do not have a valid QIB certificate with us on file.';
const COMPLIANCE_WARNING_MESSAGE_DEFAULT =
  'You do not have the ability to view the Offering Details because we are unable to verify that you have a relationship with one or more active bookrunners on this offering.';

export function getComplianceWarningMessage(hasReg144A: boolean) {
  if (hasReg144A) {
    return COMPLIANCE_WARNING_MESSAGE_CONVERTIBLE_WITH_144A;
  }
  return COMPLIANCE_WARNING_MESSAGE_DEFAULT;
}
